import { render, staticRenderFns } from "./Senarai.vue?vue&type=template&id=2af97b81&scoped=true&"
import script from "./Senarai.vue?vue&type=script&lang=js&"
export * from "./Senarai.vue?vue&type=script&lang=js&"
import style0 from "./Senarai.vue?vue&type=style&index=0&id=2af97b81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af97b81",
  null
  
)

export default component.exports